module.exports = __webpack_public_path__ + "static/img/teacher_active.33a5b05.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/suspect/images/characters/teacher_active.png
// module id = SP7T
// module chunks = 1